'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsSlope } from '@/types'
import { Chip, StatusChip } from '@/ui/components'
import { memo } from 'react'

const Label = ({ children }: { children: React.ReactNode }) => (
  <p className="textstyle-sm-regular mb-2xs text-neutral-400">{children}</p>
)

const CardSlope = ({ ...data }: Typo3ReportsSlope) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div
      className={
        'py-md gap-y-md gap-x-2xl grid border-t border-neutral-300 md:grid-cols-2 lg:flex'
      }
    >
      <div className={'md:col-span-2 lg:min-w-1/3'}>
        <Label>{D['be.tour.filter.name']}</Label>
        <div className={'gap-md flex justify-between'}>
          <p className="textstyle-md-bold">{data.title}</p>
          {data?.designation && (
            <div>
              <p className={'px-xs textstyle-md-regular bg-neutral-300'}>
                {data.designation}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className={''}>
        <Label>{D['be.tour.filter.difficulty']}</Label>
        <div className={''}>
          <Chip
            variant="fill"
            size="xs"
            iconClassName={cn(
              ' [&_path]:stroke-[white]',
              data?.difficulty === 'EASY' && 'text-[#0C6EB4]',
              data?.difficulty === 'MEDIUM' && 'text-[#E00218]',
              (data?.difficulty === 'DIFFICULT' ||
                data?.difficulty === 'HARD') &&
                'text-[#0A0A0A]',
              data?.difficulty === 'VARIANTE' && 'text-[#0A0A0A]'
            )}
            className="lg:whitespace-nowrap"
            iconLeft="material-symbols-light:circle"
          >
            {data?.difficultyLabel}
          </Chip>
        </div>
      </div>
      {data?.conditionsLabel && (
        <div className={''}>
          <Label>{D['fe.reports.tab.conditions']}</Label>
          <div>
            <p>{data?.conditionsLabel}</p>
          </div>
        </div>
      )}
      <div className={cn('justify-end md:flex md:w-full md:text-right')}>
        <div className={'md:ml-auto'}>
          <Label>{D['fe.lift.status']}</Label>
          <div className="inline-flex">
            <StatusChip
              status={data.liveStatus === 'OPEN' ? 'success' : 'error'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(CardSlope)
